import { Link } from "gatsby"
import React from "react"

export const LexiconpostsHits = ({
  hits,
  last_entry_ref,
  close_search_modal,
}) => {
  return (
    <div className="columns is-multiline">
      {hits?.map(({ title, objectID, _snippetResult, path }, i) => (
        <Link
          ref={
            i === Math.floor((hits.length / 20 - 1) * 20) - 1
              ? last_entry_ref
              : null
          }
          to={path}
          onClick={close_search_modal}
          className="column is-half"
          key={objectID}
        >
          <div
            className="box "
            style={{
              height: "100%",
              backgroundColor: "transparent",
              border: "1px solid white",
            }}
          >
            <div
              className="is-pulled-right has-background-ausschreibungsdienste is-flex"
              style={{ width: 40, height: 40 }}
            >
              <p className="m-auto has-text-white has-text-weight-bold">
                {title.charAt(0)}
              </p>
            </div>
            <p className="has-text-white title is-5">{title}</p>
            <p
              className="has-text-white internal-search-snippet"
              dangerouslySetInnerHTML={{
                __html: _snippetResult.content.value,
              }}
            ></p>
          </div>
        </Link>
      ))}
    </div>
  )
}
